import apolloClient from 'api/apolloClient';
import { SEND_SIGN_FILE_REMINDER } from 'api/queries/signService';

export async function sendSignFileReminder(documentId: string): Promise<void> {
  await apolloClient.mutate({
    mutation: SEND_SIGN_FILE_REMINDER,
    fetchPolicy: 'no-cache',
    variables: { documentId },
  });
}
